module.exports = __webpack_public_path__ + "static/media/mobilescreen1.3faf4511.png";